import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import store from "./ApplicationStore.js";
import App from "./app.jsx";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./localization/i18n.js";
import { initializeCSSLoading } from "./loadNonCriticalCSS.js";
import { initializeJSLoading } from "./loadNonCriticalJS.js";
import { initializeExternalResources } from "./utils/externalResources.js";

// Critical CSS - needed for above-the-fold content (load synchronously)
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./index.css";
import "./scss/react.scss";
import "react-datetime/css/react-datetime.css";

// Non-critical CSS will be loaded asynchronously after initial render

// Critical JavaScript - needed for basic functionality (load synchronously)
// Note: jQuery and Bootstrap JS are now loaded asynchronously for better performance

// ========================================
(() => {
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get("lang");
    if (lang) {
      localStorage.setItem("preferredLang", lang);
      console.log("Detected language:", lang);
    }
  } catch (err) {
    console.warn("Failed to parse lang param:", err);
  }

  (() => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const lang = urlParams.get("lang");
      if (lang) {
        localStorage.setItem("preferredLang", lang);
        console.log("Detected language:", lang);
      }
    } catch (err) {
      console.warn("Failed to parse lang param:", err);
    }

    // Keep Telegram-safe window.open for internal app links only
    function isTelegramMiniApp() {
      return Boolean(
          window.Telegram?.WebApp?.initData &&
          window.Telegram?.WebApp?.initDataUnsafe?.user
      );
    }

    // ✅ Keep Telegram-safe window.open for internal app links only
    (function () {
      const originalOpen = window.open;
      window.open = function (url, target, features) {
        const isTelegram = isTelegramMiniApp();
        const currentOrigin = window.location.origin;

        // Log for debugging
        console.log("window.open override:", { url, isTelegram, currentOrigin });

        // Parse target URL safely
        let targetUrl;
        try {
          targetUrl = new URL(url, currentOrigin);
        } catch (err) {
          console.error("URL parse failed:", err);
          return originalOpen.call(window, url, target || "_blank", features);
        }

        const isSameOrigin = targetUrl.origin === currentOrigin;

        // 🟢 Only handle same-origin links within Telegram
        if (isTelegram && isSameOrigin) {
          console.log("Opening same-origin page inside Telegram WebApp");
          window.location.href = targetUrl.href;
          return null;
        }

        // 🌍 For all other cases (external / Telegram games)
        // let the backend Start() handle tg.openLink or window.open logic
        return originalOpen.call(window, url, target || "_blank", features);
      };
    })();
  })();

})();

// ========================================

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// Load non-critical assets after initial render to improve performance
initializeCSSLoading();
initializeJSLoading();
initializeExternalResources();
